<div class="week-line">
  <div class="week-stats">
    <div class="week-stat" title="Kalender Woche">
      <b>KW {{ weekNr }}</b>
    </div>

    <div
      style="
        width: 2px;
        height: 24px;
        background-color: var(--main-border-color);
      "
    ></div>

    <div
      class="week-stat"
      title="Urlaubs-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['urlaub']"
      ></div>
      {{ toRoundedHours(myStats?.HOLIDAYEVENT_minutes) || 0 }}
    </div>

    <div
      class="week-stat"
      title="Meeting-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['besprechung']"
      ></div>
      {{ toRoundedHours(myStats?.MEETINGEVENT_minutes) || 0 }}
    </div>

    <div
      class="week-stat"
      title="Einsatz-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['einsatz']"
      ></div>
      {{ toRoundedHours(myStats?.MISSIONEVENT_minutes) || 0 }}
    </div>

    <div
      class="week-stat"
      title="Krank-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['krank']"
      ></div>
      {{ toRoundedHours(myStats?.SICKEVENT_minutes) || 0 }}
    </div>

    <div
      class="week-stat"
      title="Krankheitsvertretung-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['krankheitsvertretung']"
      ></div>
      {{ toRoundedHours(myStats?.ILLNESSREPRESENTATIONEVENT_minutes) || 0 }}
    </div>

    <div
      class="week-stat"
      title="Nicht Stunden Relevant-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['nichtabrechenbar']"
      ></div>
      {{ toRoundedHours(myStats?.NOTBILLABLEEVENT_minutes) || 0 }}
    </div>

    <div
      class="week-stat"
      title="Privat-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['privateintragung']"
      ></div>
      {{ toRoundedHours(myStats?.PRIVATEEVENT_minutes) || 0 }}
    </div>

    <div
      class="week-stat"
      title="Event-Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <div
        class="info-icon"
        [innerHTML]="this.svgIconService.svgCache['event']"
      ></div>
      {{ toRoundedHours(myStats?.TEAMEVENT_minutes) || 0 }}
    </div>

    <div
      style="
        width: 2px;
        height: 24px;
        background-color: var(--main-border-color);
      "
    ></div>

    <div
      class="week-stat"
      title="Alle Stunden"
      [class.content-hidden]="minutesHidden"
    >
      <b> IST: {{ toRoundedHours(myStats?.TOTAL) || 0 }}</b>
    </div>

    <div
      class="week-stat"
      title="Verfügbar"
      [class.content-hidden]="minutesHidden"
    >
      <b> SOLL: {{ availableHoursWeekly?.AVAILABLE_WEEKLY_HOURS || 0 }}</b>
    </div>

    <div
      class="week-stat"
      title="Auslastung"
      [class.content-hidden]="minutesHidden"
    >
      <b>
        Auslastung:
        {{
          (toRoundedHours(myStats?.TOTAL) /
            availableHoursWeekly?.AVAILABLE_WEEKLY_HOURS) *
            100 | number: "1.0-0"
        }}%</b
      >
    </div>
  </div>
</div>
